import { render, staticRenderFns } from "./TilFooter.vue?vue&type=template&id=08bd2014"
import script from "./TilFooter.vue?vue&type=script&lang=js"
export * from "./TilFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports